import type {MouseEvent, ReactElement} from 'react';
import {useState} from 'react';
import DialogBase from '@components/Dialog/DialogBase';
import {Plural, Trans} from '@lingui/macro';
import PrimaryButton from '@components/Button/PrimaryButton/PrimaryButton';
import styles from './topupPopup.module.scss';
import TextButton from '@components/Button/TextButton';
import {useNavigate} from 'react-router-dom';
import useQueryWithAuth from '@hooks/useQueryWithAuth';
import {me} from '@api/user';

interface Props {
    isActive: boolean;
}

export default function TopupPopup(props: Props): ReactElement<Props> {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(props.isActive);
    const query = useQueryWithAuth({
        queryKey: ['me'],
        queryFn: me,
        refetchOnWindowFocus: true,
    });

    function handleClose() {
        setIsOpen(false);
    }

    function stopPropagation(event: MouseEvent<HTMLDivElement>) {
        event.stopPropagation();
    }

    function handleTopupClick() {
        handleClose();
        navigate('/topup');
    }

    const pagesRemaining = query.data?.data.pagesRemaining ?? '...';

    return (
        <DialogBase onClose={handleClose} isOpen={isOpen} isCentered>
            <div className={styles.body} onClick={stopPropagation}>
                <div className={styles.text}>
                    <Plural
                        value={pagesRemaining}
                        one="You have # page remaining! Top up your balance to have enough for you next feedback 🙌"
                        other="You have # pages remaining! Top up your balance to have enough for you next feedback 🙌"
                    />
                </div>
                <PrimaryButton onClick={handleTopupClick} modifier="small">
                    <Trans>Top up</Trans>
                </PrimaryButton>
                <TextButton onClick={handleClose} className={styles.close}>
                    <Trans>Later</Trans>
                </TextButton>
            </div>
        </DialogBase>
    );
}

TopupPopup.defaultProps = {
    isActive: false,
};
